var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckboxOn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05473 15.5924C4.91206 15.5924 3.34073 15.5924 2.36406 14.6158C1.38806 13.6404 1.38806 12.0684 1.38806 8.92576C1.38806 5.78309 1.38806 4.21176 2.36406 3.23509C3.34139 2.25909 4.91206 2.25909 8.05473 2.25909C11.1974 2.25909 12.7687 2.25909 13.7447 3.23509C14.7214 4.21243 14.7214 5.78309 14.7214 8.92576C14.7214 12.0684 14.7214 13.6398 13.7447 14.6158C12.7694 15.5924 11.1974 15.5924 8.05473 15.5924Z",
    fill: "#00BFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9182 6.7287C11.2111 7.0216 11.2111 7.49647 10.9182 7.78936L7.58485 11.1227C7.29196 11.4156 6.81709 11.4156 6.52419 11.1227L5.19086 9.78936C4.89797 9.49647 4.89797 9.0216 5.19086 8.7287C5.48375 8.43581 5.95863 8.43581 6.25152 8.7287L7.05452 9.53171L9.85753 6.7287C10.1504 6.43581 10.6253 6.43581 10.9182 6.7287Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheckboxOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_checkbox_on.f7b941a70f1d9de3d5d1db444ee94087.svg";